export const calculateContractValue = (weekly, years) => Number.parseFloat(weekly * 52 * years).toLocaleString()
